import type { ColorToken } from '@bits2schema/shared';
import { COLOR_TOKENS } from '@bits2schema/shared';
import type { MessageKey } from '../i18n';

export { COLOR_TOKENS };

export function colorTokenBackgroundVar(token: ColorToken): string {
  return `var(--canvas-color-${token}-bg)`;
}

export function colorTokenBorderVar(token: ColorToken): string {
  return `var(--canvas-color-${token}-border)`;
}

export function colorTokenLabelKey(token: ColorToken): MessageKey {
  return `canvas.color.${token}` as MessageKey;
}
